// extracted by mini-css-extract-plugin
module.exports = {"Label":"Label_Label__3h_ca","default":"Label_default__1HS0w","success":"Label_success__lvIEy","warning":"Label_warning__1bLA5","error":"Label_error__28Tf9"};